import * as C from "../../config/constants.js";

/**
 * @returns {number} 0–0.5 fraction of flask height below bounds.top for warning line.
 */
export function getOverflowCheckBelowTopRatio() {
  var ratio = C.FLASK_OVERFLOW_CHECK_BELOW_TOP_RATIO != null
    ? Number(C.FLASK_OVERFLOW_CHECK_BELOW_TOP_RATIO)
    : 0.05;
  if (!isFinite(ratio) || ratio < 0) ratio = 0.05;
  return Math.min(0.5, ratio);
}

/** Flask mouth rim (`bounds.top`). */
export function getFlaskRimY(system) {
  if (!system || !system.bounds) return 0;
  return system.bounds.top;
}

/** Alert zone line — visible jar rim (`bounds.top`). */
export function getOverflowAlertY(system) {
  return getFlaskRimY(system);
}

/** @deprecated Use getOverflowAlertY */
export function getOverflowCheckY(system) {
  return getOverflowAlertY(system);
}

/** Warning zone line — fraction of interior height below the rim (default 5%; former alert line). */
export function getOverflowWarningY(system) {
  if (!system || !system.bounds) return 0;
  var bounds = system.bounds;
  var h = bounds.bottom - bounds.top;
  if (!isFinite(h) || h < 1) h = 1;
  return bounds.top + h * getOverflowCheckBelowTopRatio();
}

/** @deprecated Use getOverflowWarningY */
export function getOverflowNearFullY(system) {
  return getOverflowWarningY(system);
}

/**
 * @param {object|null|undefined} meta
 * @returns {number}
 */
function getBodyRadiusY(meta) {
  return (meta && (meta.radiusY || meta.radiusX || meta.radius)) || 0;
}

export function getBodyTopY(meta) {
  var body = meta && meta.body;
  if (!body) return Infinity;
  return body.position.y - getBodyRadiusY(meta);
}

/**
 * Bottom edge Y of a flask body (same radius as {@link getBodyTopY}).
 * @param {object|null|undefined} meta
 * @returns {number}
 */
export function getBodyBottomY(meta) {
  var body = meta && meta.body;
  if (!body) return Infinity;
  return body.position.y + getBodyRadiusY(meta);
}

/**
 * True when the entire body sits above the flask rim (airborne / escaped).
 * @param {object|null|undefined} meta
 * @param {import("../flask-system.js").FlaskSystem|null|undefined} system
 * @returns {boolean}
 */
export function isBodyFullyAboveFlaskRim(meta, system) {
  return getBodyBottomY(meta) <= getFlaskRimY(system);
}

/**
 * Body overlaps the overflow band at {@link zoneLineY}: top at/above the line and
 * bottom below the flask rim (inside the jar neck).
 * @param {object|null|undefined} meta
 * @param {import("../flask-system.js").FlaskSystem|null|undefined} system
 * @param {number} zoneLineY
 * @returns {boolean}
 */
export function isBodyOverlappingOverflowZone(meta, system, zoneLineY) {
  if (!meta || !system) return false;
  var rimY = getFlaskRimY(system);
  var topY = getBodyTopY(meta);
  var bottomY = getBodyBottomY(meta);
  return topY <= zoneLineY && bottomY > rimY;
}